// extracted by mini-css-extract-plugin
module.exports = {"main":"withPoint_main__zll9o","success":"withPoint_success__kBSqA","error":"withPoint_error__nTubJ","warn":"withPoint_warn__C6jY6"};